module.exports = __webpack_public_path__ + "static/media/texas.d166f5f6.mp3";